export default {
  trainings: []
}
